// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_ss_2frGlhgX","header":"_ss_3Aap9Bxe","center":"_ss_3dOIz55T","contentTop":"_ss_374_laa0","content":"_ss_6tOsP9-k","contentBottom":"_ss_GdwAL7dm","footer":"_ss_1geKMUob"};